// extracted by mini-css-extract-plugin
export default {"glass":"style_glass__ydN2o","tyre":"style_tyre__km8Aj"};